module.exports = __webpack_public_path__ + "img/logo-dark.28fe03e3.svg";